import React from 'react';
import { PlxsRadioButtonGroup } from '@plexlogic/plexus-ui';

interface WizardRadioButtonGroupProps {
  dataTestId: string;
  name: string;
  options: Array<{ value: string; label: string }>;
  value: string;
  onChange: (value: string) => void;
  isDisabled?: boolean;
}

const WizardRadioButtonGroup: React.FC<WizardRadioButtonGroupProps> = ({
  dataTestId,
  name,
  options,
  value,
  onChange,
  isDisabled = false
}) => {
  return (
    <div style={{ 
      margin: 0,
      padding: 0
    }}>
      <style>{`
        [data-testid="${dataTestId}"] fieldset {
          border: none !important;
          margin: 0 !important;
          margin-bottom: 0 !important;
          padding: 0 !important;
        }
        [data-testid="${dataTestId}"] {
          border: none !important;
          margin: 0 !important;
          margin-bottom: 0 !important;
        }
        [data-testid="${dataTestId}"] > div {
          padding: 0 !important;
          margin: 0 !important;
          margin-bottom: 0 !important;
        }
        
        /* Remove any makeStyles margin-bottom applied by Plexus */
        [data-testid="${dataTestId}"] [class*="makeStyles-marginBottom"] {
          margin-bottom: 0 !important;
        }
        
        /* Enhanced spacing for specific radio groups */
        [data-testid="header-row-radio-group"] fieldset > div,
        [data-testid="file-structure-radio-group"] fieldset > div {
          margin-top: var(--plexus-space-sm, 8px) !important;
        }
        
        /* Ensure radio button options have consistent spacing while maintaining alignment */
        [data-testid="header-row-radio-group"] label,
        [data-testid="file-structure-radio-group"] label {
          margin-top: var(--plexus-space-xs, 4px) !important;
          margin-bottom: var(--plexus-space-xs, 4px) !important;
        }
        
        /* Remove bottom margins to eliminate spacing between questions */
        [data-testid="header-row-radio-group"],
        [data-testid="file-structure-radio-group"] {
          margin-bottom: 0 !important;
        }
      `}</style>
      <PlxsRadioButtonGroup
        dataTestId={dataTestId}
        name={name}
        options={options}
        value={value}
        onChange={onChange}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default WizardRadioButtonGroup;
